define('casino/providers/CTXM',['jquery'], function ($) {
    'use strict';

    function CTXM(casino, gameFunctions) {
        if (!(this instanceof CTXM)) {
            throw new TypeError('CTXM constructor cannot be called as a function.');
        }

        this.casino = casino;
        this.gameFunctions = gameFunctions;
    }

    function freeMode(ctxm, game, options) {
        ctxm.gameFunctions.showHelpButton();
        var provider = ctxm.casino.getProvider(game);
        var src = provider.url;
        src += $.param({
            game_code: game.code,
            merch_id: provider.merchantId,
            merch_login_url: provider.merchantLoginURL,
            singlegame: 'true',
            language: provider.language,
            lockPlaymode: 'true',
            disableLogout: 'true',
            playmode: 'fun',
            wmode: 'transparent',
            serverBaseURL: provider.siteBaseContext
        });
        ctxm.gameFunctions.switchToFreeMode(game, {
            gameHolder: options.gameHolder,
            type: 'iframe',
            src: src
        });
    }

    function realMode(ctxm, game, options, data) {
        ctxm.gameFunctions.showHelpButton();
        var provider = ctxm.casino.getProvider(game);
        var src = provider.url;
        src += $.param({
            game_code: game.code,
            merch_id: provider.merchantId,
            merch_login_url: provider.merchantLoginURL,
            singlegame: 'true',
            language: provider.language,
            lockPlaymode: 'true',
            disableLogout: 'true',
            merch_ticket: data.merchantTicket,
            playmode: 'real',
            wmode: 'transparent',
            serverBaseURL: provider.siteBaseContext
        });
        ctxm.gameFunctions.switchToRealMode(game, {
            gameHolder: options.gameHolder,
            type: 'iframe',
            src: src
        });
        ctxm.gameFunctions.verifyCurrency(data.currency);
    }

    CTXM.prototype = {
        constructor: CTXM,
        freeMode: function (game, options) {
            freeMode(this, game, options);
        },
        realMode: function (game, options, data) {
            realMode(this, game, options, data);
        }
    };

    return CTXM;
});
